import React from 'react';
import TextField from '@mui/material/TextField';
import FieldLabel from '../components/FieldLabel';
import { getFieldLabel } from '../utils/formHelpers';
import { outlinedFieldProps } from '../utils/fieldStyles';

const TimeField = ({ field, data, change, hasError, errorMessage }) => (
    <TextField
        {...outlinedFieldProps}
        label={<FieldLabel label={getFieldLabel(field)} tooltip={field.tooltip} />}
        type="time"
        value={data[field.key] || ''}
        onChange={(e) => change(field.key, e.target.value)}
        error={hasError}
        helperText={hasError ? (errorMessage || 'This field is required') : ''}
        InputLabelProps={{ shrink: true }}
    />
);

export default TimeField;
